import { Box, Popover, PopoverArrow, PopoverContent, PopoverTrigger, Portal } from '@chakra-ui/react'
import type { PropsWithChildren, ReactElement } from 'react'
import { DataCompletenessIndicatorContent } from './DataCompletenessIndicatorContent'
import { DataCompletenessTag } from './DataCompletenessTag'
import type { DataCompletenessScope } from './dataCompleteness.mapper'
import type { IDataCompletenessItem } from './dataCompletenessIndicator.utils'

interface DataCompletenessIndicatorPopoverProps {
  items: IDataCompletenessItem[]
  timeframe: string
  description?: string
  qualityPercentage: number | null | undefined
  icon?: ReactElement
  isLoading?: boolean
  onlyShowIncompleteItems?: boolean
  scope: DataCompletenessScope
  withPortal?: boolean
  tagLabelMode?: 'full' | 'compact'
  tagSize?: 'default' | 'small'
  content?: ReactElement
}

export const DataCompletenessIndicator = ({
  children,
  items,
  timeframe,
  description,
  qualityPercentage,
  icon,
  isLoading = false,
  onlyShowIncompleteItems = false,
  scope,
  withPortal = true,
  tagLabelMode = 'full',
  tagSize = 'default',
  content,
}: PropsWithChildren<DataCompletenessIndicatorPopoverProps>) => {
  const popoverContent = (
    <PopoverContent
      w='auto'
      p={0}
      border='none'
      shadow='none'
      bg='transparent'
      zIndex='popover'
      _focus={{ outline: 'none', boxShadow: 'none' }}
    >
      <PopoverArrow bg='background' shadowColor='border' />
      {content ?? (
        <DataCompletenessIndicatorContent
          items={items}
          timeframe={timeframe}
          description={description}
          onlyShowIncompleteItems={onlyShowIncompleteItems}
          scope={scope}
        />
      )}
    </PopoverContent>
  )

  return (
    <Popover trigger='hover' placement='end' openDelay={50} closeDelay={100} isLazy>
      <PopoverTrigger>
        <Box width='max-content' flexShrink={0}>
          {children ?? (
            <DataCompletenessTag
              qualityPercentage={qualityPercentage}
              hasItems={items.length > 0}
              icon={icon}
              isLoading={isLoading}
              labelMode={tagLabelMode}
              size={tagSize}
            />
          )}
        </Box>
      </PopoverTrigger>
      {withPortal ? <Portal>{popoverContent}</Portal> : popoverContent}
    </Popover>
  )
}
